/**
 * @fileoverview PATCH handler for the "/app_groups/:app_group_id/placements/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appGroupsAppGroupIdPlacementsIdCacheKeys } from "./constants";
import type {
  PatchAppGroupsAppGroupIdPlacementsIdProps,
  PatchAppGroupsAppGroupIdPlacementsIdResult,
} from "./types";

export const patchAppGroupsAppGroupIdPlacementsId = reactQueryMutationAdapter(
  appGroupsAppGroupIdPlacementsIdCacheKeys,
  ({
    id,
    placementId,
    name,
    description,
    appGroupId,
  }: PatchAppGroupsAppGroupIdPlacementsIdProps): Promise<PatchAppGroupsAppGroupIdPlacementsIdResult> => {
    return fetch(
      `/app_groups/${appGroupId}/placements/${id}`,
      "PATCH",
      {
        placement_id: placementId,
        name,
        description,
      },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
